// NOTE: This is an apollo-client query
import gql from "graphql-tag";
import { entryFragmentsForExport } from "./entryFragmentsForExport";
import { manualFragmentsForExport } from "./manualFragmentsForExport";

// IMPORTANT: do not prettify this file, in my editor when I did so, it removed important commas within the mutation string template.
// This query differs slightly from the ManualQuery.js. It leaves out image blocks that won't be needed during translation, and it adds the sortOrder field that we use during import to the return values.
// prettier-ignore
const QUERY_LIVE_MANUAL_EXPORT = gql`
  query($id: [QueryArgument], $siteId: [QueryArgument]) {

    globalSets(siteId: $siteId) {
      handle
      ... on customerSupport_GlobalSet {
        localeSupportInfo {
          ... on supportblock_Entry {
            id
            localeTitle
            locality
            phone
            internationalPhone
            email
            addressLine1
            addressLine2
          }
        }
      }
      ... on translations_GlobalSet {
        translationKeyValuePairs {
          labelKey
          labelValue
        }
      }
    }

    glossary: entries(section: "glossary", siteId: $siteId) {
      ... on glossaryTerm_Entry {
        id
        title
        definition { rawHtml }
      }
    }  

    globalVariables: entries(section: "variables", siteId: $siteId, type: ["variable"]) {
      id  # need id only for global variables as they may be overridden by product scoped variables, nested variables are not implemented yet
      ...VariableEntryFields
    }

    entry(id: $id, siteId: $siteId, status: ["enabled","disabled"]) {
      id
      siteId
      siteHandle
      language
      typeHandle
      sectionHandle
      title
      # If it's a product
      ... on product_Entry {
        ...ProductEntryFields
      }

      # If it has children that are chapter_Entries
      children {
        id
        ... on chapter_Entry {
          ...ChapterEntryFields
        }
      }
    }
  }

  # Spread the imported fragments so GraphQL is aware of them.
  # You only need to include the "top-level" fragments here.
  # The rest will chain because they're nested inside each other.
  ${entryFragmentsForExport}

  ${manualFragmentsForExport}

`;

export default QUERY_LIVE_MANUAL_EXPORT;
